import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CoreConfig } from 'src/app/models/core-config.model';
import { AuthService } from '../auth.service';

@Component({
  selector: 'page-forbidden',
  templateUrl: './page-forbidden.html',
  standalone: false,
})
export class PageForbiddenComponent {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {
    this.config = this.authService.getCoreConfig();
  }

  config!: CoreConfig;

  return() {
    this.router.navigate([this.config.redirectPathAfterLogin]);
  }
}
